import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

GoogleRecaptchaForm.propTypes = {
  siteKey: PropTypes.string,
  language: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onExpired: PropTypes.func,
};

GoogleRecaptchaForm.defaultProps = {
  siteKey: process.env.REACT_APP_GOOGLE_RECAPTCHA_V2_SITE_KEY ?? '',
  language: 'vi',
  onSuccess: null,
  onError: null,
  onExpired: null,
};

function GoogleRecaptchaForm(props) {
  const { siteKey, language, onSuccess, onError, onExpired } = props;

  return (
    <div>
      <ReCAPTCHA
        className="w-100"
        sitekey={siteKey}
        hl={language}
        onChange={(value) => {
          if (value && onSuccess) {
            onSuccess();
          }
        }}
        onErrored={() => {
          if (onError) {
            onError();
          }
        }}
        onExpired={() => {
          if (onExpired) {
            onExpired();
          }
        }}
      />
    </div>
  );
}

export default GoogleRecaptchaForm;